import { Link } from "react-router-dom";
import BrandWordmark from "./BrandWordmark";
import { useTranslation } from "./i18n";
import LanguageSwitcher from "./LanguageSwitcher";
import { legalConfig } from "./lib/legal";

export default function SupportPage() {
  const { t } = useTranslation("support");
  const emailLink = (subject: string) => `mailto:${legalConfig.contactEmail}?subject=${encodeURIComponent(subject)}`;
  return (
    <main className="legal-shell" id="main-content" aria-labelledby="support-title" tabIndex={-1}>
      <a className="skip-link" href="#main-content">
        {t("skip")}
      </a>
      <header>
        <Link to="/" className="brand-home">
          <BrandWordmark />
        </Link>
        <nav aria-label={t("navigation")}>
          <Link to="/privacy">{t("privacy")}</Link>
          <Link to="/terms">{t("terms")}</Link>
          <Link to="/app">{t("app")}</Link>
        </nav>
        <LanguageSwitcher />
      </header>
      <article className="legal-document">
        <h1 id="support-title">{t("title")}</h1>
        <p>{t("intro", { operator: legalConfig.operatorName })}</p>
        <p>
          <a href={`mailto:${legalConfig.contactEmail}`}>{legalConfig.contactEmail}</a>
        </p>
        <section>
          <h2>{t("helpTitle")}</h2>
          <p>{t("help")}</p>
          <p>{t("safeDetails")}</p>
          <p>{t("response")}</p>
          <a href={emailLink(t("helpSubject"))}>{t("helpAction")}</a>
        </section>
        <section id="delete-account">
          <h2>{t("deleteTitle")}</h2>
          <p>{t("deleteBefore")}</p>
          <ol>
            <li>{t("deleteRequest")}</li>
            <li>{t("deleteVerify")}</li>
            <li>{t("deleteComplete")}</li>
          </ol>
          <p>{t("deleteScope")}</p>
          <p>{t("deleteLocal")}</p>
          <p>{t("deadline")}</p>
          <a href={emailLink(t("deleteSubject"))}>{t("deleteAction")}</a>
          <p>{t("emailNotice")}</p>
        </section>
        <section id="privacy-requests">
          <h2>{t("rightsTitle")}</h2>
          <p>{t("rights")}</p>
          <a href={emailLink(t("rightsSubject"))}>{t("rightsAction")}</a>
        </section>
        <section>
          <h2>{t("feedbackTitle")}</h2>
          <p>{t("feedback")}</p>
          <p>{t("feedbackRetention")}</p>
        </section>
        <section id="security">
          <h2>{t("securityTitle")}</h2>
          <p>{t("security")}</p>
          <a href={emailLink(t("securitySubject"))}>{t("securityAction")}</a>
        </section>
      </article>
    </main>
  );
}
